import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import type { TW } from 'twind'

export type TwindContextProps = {
  tw: TW | undefined
}

export const TwindContext = createContext<TwindContextProps>({
  tw: undefined,
})

/** Provider component for Twind */
export const TwindProvider: FC<PropsWithChildren<TwindContextProps>> = ({
  tw,
  children,
}) => {
  return (
    <TwindContext.Provider
      value={{
        tw,
      }}
    >
      {children}
    </TwindContext.Provider>
  )
}

/** @returns TwindContext */
export const useTwindContext = () => {
  return useContext(TwindContext)
}
